import { render, staticRenderFns } from "./EventsTopFundraisersLegacy.vue?vue&type=template&id=ecba9070&scoped=true&lang=html&"
import script from "./EventsTopFundraisersLegacy.vue?vue&type=script&lang=js&"
export * from "./EventsTopFundraisersLegacy.vue?vue&type=script&lang=js&"
import style0 from "./EventsTopFundraisersLegacy.vue?vue&type=style&index=0&id=ecba9070&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecba9070",
  null
  
)

export default component.exports